import { ReactNode, useState } from "react";
import { Button, Collapse, Icons } from "@pushpress/shared-components";

export default function ActionsMenu({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Button
        text="Before you begin..."
        buttonType="text"
        icon={isOpen ? Icons.CaretDown : Icons.CaretRight}
        iconLocation="left"
        onClick={() => setIsOpen(!isOpen)}
        style={{ color: "black" }}
      />
      <Collapse in={isOpen}>{children}</Collapse>
    </>
  );
}
